module.exports = __webpack_public_path__ + "static/media/21nocards.2f862f68.png";